import {
  TriggerScopeType,
  useArtifactCollectionNameFromIdQuery,
} from '../../../../generated/graphql';
import {propagateErrorsContext} from '../../../../util/errors';
import {TriggerScope} from './utilTypes';

export function useTriggerArtifactCollectionName(triggerScope: TriggerScope) {
  const {data, loading, error} = useArtifactCollectionNameFromIdQuery({
    variables: {
      artifactCollectionID: triggerScope.id,
    },
    context: propagateErrorsContext(),
    skip:
      triggerScope.id === '' || triggerScope.scope === TriggerScopeType.Project,
  });
  const artifactCollectionName = data?.artifactCollection?.name ?? '';
  return {data: artifactCollectionName, loading, error};
}
